import getRequest from 'utils/getRequest'

const path = '/api/webmapConfig/'

export const requestWebmapConfig = () => {
  return getRequest(path)
}
